// The frame's icons (Material Symbols, Outlined, as 07 names), in the signed-in chunk only.
import add from '@material-symbols/svg-400/outlined/add.svg?raw';
import arrowForward from '@material-symbols/svg-400/outlined/arrow_forward.svg?raw';
import alternateEmail from '@material-symbols/svg-400/outlined/alternate_email.svg?raw';
import bookmark from '@material-symbols/svg-400/outlined/bookmark.svg?raw';
import chat from '@material-symbols/svg-400/outlined/chat.svg?raw';
import chevronLeft from '@material-symbols/svg-400/outlined/chevron_left.svg?raw';
import chevronRight from '@material-symbols/svg-400/outlined/chevron_right.svg?raw';
import doneAll from '@material-symbols/svg-400/outlined/done_all.svg?raw';
import expandMore from '@material-symbols/svg-400/outlined/keyboard_arrow_down.svg?raw';
import groupFill from '@material-symbols/svg-400/outlined/group-fill.svg?raw';
import gridView from '@material-symbols/svg-400/outlined/grid_view.svg?raw';
import homeFill from '@material-symbols/svg-400/outlined/home-fill.svg?raw';
import link from '@material-symbols/svg-400/outlined/link.svg?raw';
import lock from '@material-symbols/svg-400/outlined/lock.svg?raw';
import logout from '@material-symbols/svg-400/outlined/logout.svg?raw';
import mail from '@material-symbols/svg-400/outlined/mail.svg?raw';
import palette from '@material-symbols/svg-400/outlined/palette.svg?raw';
import publicIcon from '@material-symbols/svg-400/outlined/public.svg?raw';
import personAddFill from '@material-symbols/svg-400/outlined/person_add-fill.svg?raw';
import search from '@material-symbols/svg-400/outlined/search.svg?raw';
import settings from '@material-symbols/svg-400/outlined/settings.svg?raw';
import settingsFill from '@material-symbols/svg-400/outlined/settings-fill.svg?raw';
import star from '@material-symbols/svg-400/outlined/star.svg?raw';
import starFill from '@material-symbols/svg-400/outlined/star-fill.svg?raw';
import shield from '@material-symbols/svg-400/outlined/encrypted.svg?raw';
import tag from '@material-symbols/svg-400/outlined/tag.svg?raw';
import tagFill from '@material-symbols/svg-400/outlined/tag-fill.svg?raw';
import volumeUp from '@material-symbols/svg-400/outlined/volume_up.svg?raw';
import workspacesFill from '@material-symbols/svg-400/outlined/workspaces-fill.svg?raw';

/**
 * desyr's own Direct messages bubble (07, The rail, item 3): a 24-unit square, the body 2–22 × 3.5–19
 * with 3-unit corners, the tail at the bottom left down to a rounded tip, three dot holes on the
 * middle line. Drawn as it is (no stroke): its lines aren't Material's.
 */
const bubble = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path style="stroke:none" fill-rule="evenodd" d="M5 3.5H19A3 3 0 0 1 22 6.5V16A3 3 0 0 1 19 19H9.6L5.15 21.95Q4.25 22.6 4.25 21.6V18.9A3 3 0 0 1 2 16V6.5A3 3 0 0 1 5 3.5ZM6.15 11.25A1.45 1.45 0 1 0 9.05 11.25A1.45 1.45 0 1 0 6.15 11.25ZM10.55 11.25A1.45 1.45 0 1 0 13.45 11.25A1.45 1.45 0 1 0 10.55 11.25ZM14.95 11.25A1.45 1.45 0 1 0 17.85 11.25A1.45 1.45 0 1 0 14.95 11.25Z"/></svg>`;

export const frameIcons = {
  add, alternateEmail, arrowForward, bookmark, chat, chevronLeft, chevronRight, doneAll, expandMore, gridView, groupFill, homeFill, link, lock,
  logout, mail, palette, personAddFill, public: publicIcon, bubble, search, settings, settingsFill, shield, star, starFill, tag, tagFill, volumeUp, workspacesFill,
};
